import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'

import { initI18N } from '../../i18next';


const container = document.querySelector("div[id^='cart-app'");

initI18N().then(() => {
    const root = createRoot(container);
    root.render(<App />);
});